import TextField from '@/components/fields/TextField.vue';
import TextareaField from '@/components/fields/TextareaField.vue';
import InfoField from '@/components/fields/InfoField.vue';
import SelectField from '@/components/fields/SelectField.vue';
import CatalogField from '@/components/fields/CatalogField.vue';
import DateField from '@/components/fields/DateField.vue';
import FileUploadField from '@/components/fields/FileUploadField.vue';

const components = {
  TextField,
  TextareaField,
  InfoField,
  SelectField,
  CatalogField,
  DateField,
  FileUploadField,
};

export default components;
